<template>
  <div>
    <slot
      :loadMore="loadMore"
      :hasMore="hasMore"
    ></slot>
  </div>
</template>

<script lang="js">
export default {
  name: 'ahc-block-list',
  props: {
    totalRows: {
      type: Number,
      default: 1,
    },
    startingRowIndex: {
      type: Number,
      default: 1,
    }
  },
  data() {
    return {
      listItems: [],
      currentRowIndex: 1
    }
  },
  computed: {
    hasMore() {
      return this.currentRowIndex < this.totalRows;
    }
  },
  mounted() {
    this.listItems = this.$el.querySelectorAll('.block-list__item');
    this.currentRowIndex = this.startingRowIndex;
  },
  methods: {
    loadMore() {
      if(!this.hasMore) { return; }

      this.currentRowIndex++;

      this.listItems.forEach(rowItem => {
        if(rowItem.classList.contains(`block-list__item-row-${this.currentRowIndex}`)) {
          rowItem.classList.remove('block-list__item--hidden');
        }
      });
    }
  }
}
</script>
